"use client";

import Link from "next/link";
import { useEffect, useMemo, useState } from "react";
import { CartItem } from "@/lib/types";

export function CheckoutClient() {
  const [items, setItems] = useState<CartItem[]>([]);
  const [status, setStatus] = useState<string>("");

  useEffect(() => {
    const id = window.setTimeout(() => {
      setItems(JSON.parse(localStorage.getItem("cart") || "[]") as CartItem[]);
    }, 0);
    return () => window.clearTimeout(id);
  }, []);

  const total = useMemo(() => items.reduce((sum, item) => sum + (item.priceRub || 0) * item.qty, 0), [items]);

  function save(next: CartItem[]) {
    setItems(next);
    localStorage.setItem("cart", JSON.stringify(next));
  }

  async function submit(formData: FormData) {
    setStatus("Отправляю заявку...");
    const payload = {
      name: String(formData.get("name") || ""),
      phone: String(formData.get("phone") || ""),
      comment: String(formData.get("comment") || ""),
      items: items.map(({ id, name, qty, priceRub }) => ({ id, name, qty, priceRub })),
    };
    const res = await fetch("/api/orders", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
    const data = await res.json();
    if (data.ok) {
      localStorage.removeItem("cart");
      setItems([]);
      setStatus(data.message || "Заявка принята");
    } else setStatus(data.error || "Ошибка отправки");
  }

  return (
    <main className="min-h-screen bg-[#f6f1e8] px-6 py-8 text-stone-950">
      <div className="mx-auto max-w-5xl">
        <Link href="/" className="text-sm font-bold text-stone-600">← Вернуться в каталог</Link>
        <h1 className="mt-6 text-4xl font-black">Корзина / заявка</h1>
        <p className="mt-3 text-stone-600">Сейчас заявка работает в тестовом режиме: запись в МойСклад выключена до отдельного подтверждения.</p>

        <div className="mt-8 grid gap-6 lg:grid-cols-[1fr_360px]">
          <section className="rounded-3xl bg-white p-5 shadow-sm ring-1 ring-stone-200">
            {items.length === 0 ? <p>Корзина пустая.</p> : items.map((item) => (
              <div key={item.id} className="flex items-center justify-between gap-4 border-b border-stone-100 py-4 last:border-0">
                <div>
                  <div className="font-bold">{item.name}</div>
                  <div className="text-sm text-stone-500">{item.article ? `Арт. ${item.article}` : item.pathName}</div>
                </div>
                <div className="flex items-center gap-2">
                  <button className="rounded-lg bg-stone-100 px-3 py-1" onClick={() => save(items.map((p) => p.id === item.id ? { ...p, qty: Math.max(1, p.qty - 1) } : p))}>−</button>
                  <span className="w-8 text-center font-bold">{item.qty}</span>
                  <button className="rounded-lg bg-stone-100 px-3 py-1" onClick={() => save(items.map((p) => p.id === item.id ? { ...p, qty: p.qty + 1 } : p))}>+</button>
                </div>
              </div>
            ))}
            <div className="mt-5 text-right text-2xl font-black">Итого: {total ? `${total.toLocaleString("ru-RU")} ₽` : "по запросу"}</div>
          </section>

          <form action={submit} className="h-fit rounded-3xl bg-white p-5 shadow-sm ring-1 ring-stone-200">
            <h2 className="text-xl font-bold">Данные покупателя</h2>
            <label className="mt-4 block text-sm font-bold">Имя</label>
            <input name="name" required className="mt-1 w-full rounded-xl border border-stone-300 px-4 py-3" />
            <label className="mt-4 block text-sm font-bold">Телефон</label>
            <input name="phone" required className="mt-1 w-full rounded-xl border border-stone-300 px-4 py-3" />
            <label className="mt-4 block text-sm font-bold">Комментарий</label>
            <textarea name="comment" rows={4} className="mt-1 w-full rounded-xl border border-stone-300 px-4 py-3" />
            <button disabled={!items.length} className="mt-5 w-full rounded-2xl bg-stone-950 px-5 py-3 font-bold text-white disabled:opacity-40">Отправить заявку</button>
            {status && <div className="mt-4 rounded-xl bg-amber-50 p-3 text-sm text-amber-900">{status}</div>}
          </form>
        </div>
      </div>
    </main>
  );
}
